/* eslint-disable */
const getDefaultState = () => {
  return {
    deepAncestryCoordinate: null,
    kitId: null,
    kitName: null,
    default_ethnicity: null,

    gender: 'M',
    isYouByDNAKit: 'You',

    new_badge_menus: '',
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
